"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteClassButton = void 0;
var deleteClassButton_1 = require("./deleteClassButton");
Object.defineProperty(exports, "DeleteClassButton", { enumerable: true, get: function () { return __importDefault(deleteClassButton_1).default; } });
